var _g, _g2, _g3, _g4, _g5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGift(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "emoji",
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "color"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D22F27",
    stroke: "none",
    d: "M51.024,14.0213c-1.6705-3.0089-3.6713-4.5339-5.9477-4.5339c-2.6203,0-5.3416,2.0624-8.0912,6.133 c-0.3517,0.521-0.6812,1.042-0.985,1.5449c-0.3038-0.5029-0.6333-1.0238-0.9857-1.5449c-2.7479-4.0705-5.4701-6.133-8.0904-6.133 c-2.2762,0-4.278,1.5249-5.9476,4.5339c-1.2484,2.252-1.1453,4.0191-0.548,4.9787c1.0765,1.7294,3.8299,2.7454,7.7039,3.4114 C31.1069,22.9241,34.2545,23,35.8658,23h0.0009c0.0453,0,0.0898,0,0.1335,0c0.0445,0,0.0889,0,0.1344,0 c1.6114,0,4.759-0.0759,7.7336-0.5886c3.8731-0.666,6.6256-1.682,7.7039-3.4114C52.1675,18.0404,52.2734,16.2734,51.024,14.0213z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 36,
    width: 39,
    height: 25,
    fill: "#FCEA2B",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f1b31c",
    stroke: "none",
    points: "53.3905,35.5 17,35.5581 17,41.0581 44.1429,44.9866 55,46.5 55,35.5581"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#EA5A47",
    stroke: "none",
    points: "29.7143,60 42.2857,60 42.2857,44.2729 29.7143,41.7857"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 21,
    width: 44,
    height: 14,
    fill: "#FCEA2B",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.7143,
    y: 22,
    width: 12.5714,
    height: 13,
    fill: "#EA5A47",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#D22F27",
    stroke: "none",
    points: "42.2857,35.5 29.7143,35.5202 29.7143,42.8737 42.2857,44.7071"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "hair"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "skin"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "skin-shadow"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "line"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 54.0913,
    x2: 17.3557,
    y1: 21.3571,
    y2: 21.3571,
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    points: "17.3557,21.3571 14,21.3571 14,35.5 16.3571,35.5 16.3571,60.6429 55.6429,60.6429 55.6429,35.5 58,35.5 58,21.3571 54.0913,21.3571"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.3571,
    x2: 56.4286,
    y1: 35.5,
    y2: 35.5,
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M50.9612,18.2506c0.3839-0.9798,0.4917-2.3937-0.4893-4.2293c-1.6091-3.0089-3.5365-4.5339-5.7293-4.5339 c-2.5241,0-5.1454,2.0624-7.794,6.133c-0.3388,0.521-0.6562,1.042-0.9488,1.5449c-0.2926-0.5029-0.61-1.0238-0.9495-1.5449 c-2.647-4.0705-5.2692-6.133-7.7933-6.133c-2.1926,0-4.1209,1.5249-5.7292,4.5339c-0.9019,1.689-0.8835,3.0211-0.5752,3.9863"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 42.2857,
    x2: 42.2857,
    y1: 60,
    y2: 44.2729,
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 29.7143,
    x2: 29.7143,
    y1: 41.7857,
    y2: 60,
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 42.2857,
    x2: 42.2857,
    y1: 35,
    y2: 22,
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 29.7143,
    x2: 29.7143,
    y1: 22,
    y2: 35,
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    points: "42.2857,44.7071 42.2857,35.5 29.7143,35.5202 29.7143,42.8737"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.736517a2cc7f807e2ec9125e6c97de01.svg";
export { ForwardRef as ReactComponent };